import React from "react";

const VIDEO_EXT = /\.(mp4|webm|mov)(\?|#|$)/i;

/**
 * Renders the site's brand logo. Auto-detects whether the URL points at a
 * video (.mp4 / .webm / .mov) and renders a muted, autoplay, looping <video>
 * in that case. Otherwise renders an <img>. Aspect ratio is always preserved
 * via `w-auto object-contain` — the uploaded file's shape decides everything.
 */
export default function BrandLogo({ src, alt = "LAST", className = "" }) {
  if (!src) return null;
  const url = src;
  const isVideo = VIDEO_EXT.test(url);
  const merged = `${className} w-auto object-contain`;

  if (isVideo) {
    return (
      <video
        src={url}
        autoPlay
        muted
        loop
        playsInline
        aria-label={alt}
        className={merged}
        data-testid="brand-logo-video"
      />
    );
  }
  return (
    <img
      src={url}
      alt={alt}
      className={merged}
      data-testid="brand-logo-img"
    />
  );
}
